import { render } from "./form-element.vue?vue&type=template&id=5afefe05"
import script from "./form-element.vue?vue&type=script&lang=ts"
export * from "./form-element.vue?vue&type=script&lang=ts"
script.render = render

export default script